import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useSnackbar } from 'src/components/snackbar';
import { useLocales } from 'src/locales';
import { syncFicVatData } from 'src/api/admin';

export default function FicSyncControls() {
  const { t } = useLocales('ficSync');
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const handleSync = async () => {
    setLoading(true);
    try {
      const response = await syncFicVatData();
      const data = response?.data?.data;
      const message = data
        ? `${t('sync_success')}: ${data.clientsUpdated} ${t('clients_updated')}`
        : t('sync_success');
      enqueueSnackbar(message, { variant: 'success' });
    } catch (error: any) {
      console.error('FIC VAT Sync failed:', error);
      enqueueSnackbar(error?.response?.data?.message || t('sync_error'), { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t('title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t('description')}
        </Typography>
        <Stack direction="row" spacing={2}>
          <Button variant="contained" onClick={handleSync} disabled={loading}>
            {loading ? t('syncing_vat') : t('sync_vat')}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
